import { useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { CardsSection } from 'academy-common-lib/features/cardsSection/components/CardsSection';
import { LiveEventFooter } from 'academy-common-lib/features/liveEvents/components/LiveEventFooter';
import { toLiveEventCardModel } from 'academy-common-lib/features/liveEvents/toLiveEventCardModel';
import { MYLEARNING_URL_FRAGMENT } from '../../../constants/Navigation';
import { useLearningEvents } from 'academy-common-lib/features/liveEvents/liveEventQueries';
import OnboardingSectionLayout from './OnboardingSectionLayout';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VIEW_REGISTERED_EVENTS_TO = `${MYLEARNING_URL_FRAGMENT}?contentType=LIVE_EVENT`;
const DEFAULT_PAGE_LENGTH = 4;
const LiveEventSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  const [maxCards, setMaxCards] = useState();
  const [offset, setOffset] = useState();
  const [cursorStack, setCursorStack] = useState([]);
  const pageLength = maxCards !== null && maxCards !== void 0 ? maxCards : DEFAULT_PAGE_LENGTH;
  const {
    learningEvents,
    learningEventsHasMore,
    learningEventsNextOffset,
    learningEventsLoading
  } = useLearningEvents({
    pageLength,
    offset
  });
  const eventsByCardId = useMemo(() => {
    const result = new Map();
    learningEvents.forEach(event => result.set(event.id, event));
    return result;
  }, [learningEvents]);
  const cardModels = useMemo(() => learningEvents.map(toLiveEventCardModel), [learningEvents]);
  const handleClickNext = () => {
    if (!learningEventsNextOffset) return;
    setCursorStack(stack => [...stack, offset]);
    setOffset(learningEventsNextOffset);
  };
  const handleClickPrevious = () => {
    setCursorStack(stack => {
      if (stack.length === 0) return stack;
      const next = stack.slice(0, -1);
      setOffset(stack[stack.length - 1]);
      return next;
    });
  };
  const renderFooter = cardModel => {
    const liveEventModel = cardModel;
    const event = eventsByCardId.get(liveEventModel.id);
    if (!event) return null;
    return /*#__PURE__*/_jsx(LiveEventFooter, {
      attended: event.attended,
      eventType: event.eventType,
      nextRegisteredSession: event.nextRegisteredSession,
      nextUpcomingEventSession: event.nextUpcomingEventSession
    });
  };
  return /*#__PURE__*/_jsx(OnboardingSectionLayout, {
    children: /*#__PURE__*/_jsx(CardsSection, {
      appearsIn: "academy-onboarding-live-event",
      content: cardModels,
      description: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.academyOnboarding.liveEvent.description"
          })
        }), /*#__PURE__*/_jsx(RouterLink, {
          to: VIEW_REGISTERED_EVENTS_TO,
          underline: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.academyOnboarding.liveEvent.showRegistered"
          })
        })]
      }),
      direction: isMobile ? 'column' : 'row',
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.academyOnboarding.liveEvent.title"
      }),
      isLoading: learningEventsLoading,
      maxSkeletonListLength: 3,
      onClickNext: handleClickNext,
      onClickPrevious: handleClickPrevious,
      renderFooter: renderFooter,
      setMaxCards: setMaxCards,
      showNext: learningEventsHasMore,
      showOverview: true,
      showPrevious: cursorStack.length > 0,
      size: isMobile ? 'small' : 'large'
    })
  });
};
export default LiveEventSection;